
import React from 'react';
import { Link } from 'react-router-dom';

export const Logo: React.FC = () => {
  return (
    <Link 
      to="/" 
      className="flex items-center space-x-2 transition-opacity hover:opacity-80"
    >
      <img 
        src="/lovable-uploads/a9aba44d-dd97-4587-89f4-832d11551e38.png" 
        alt="Dropify" 
        className="h-10" 
      />
    </Link>
  );
};
